/**
 * Tags used to categorize the data source/method for manufacturer harvest records.
 * These tags indicate how product data is collected from manufacturers.
 *
 * IMPORTANT: Keep in sync with backend enum:
 * app/lib/enums/global_manufacturer_harvest/global_manufacturer_harvest_tags.py
 */

export const GLOBAL_MANUFACTURER_HARVEST_TAGS = {
  GDSN: 'GDSN',
  SUPPLIER_PORTAL: 'Supplier Portal',
  SCRAPED: 'Scraped',
  MANUAL_ENTRY: 'Manual Entry',
  API_INTEGRATION: 'API Integration',
  CATALOGUE_UPLOADED: 'Catalogue Uploaded',
};

/**
 * Get tags formatted for dropdown/select components
 * @returns {Array<{value: string, label: string}>}
 */
export const getAvailableTags = () => [
  { value: GLOBAL_MANUFACTURER_HARVEST_TAGS.GDSN, label: GLOBAL_MANUFACTURER_HARVEST_TAGS.GDSN },
  {
    value: GLOBAL_MANUFACTURER_HARVEST_TAGS.SUPPLIER_PORTAL,
    label: GLOBAL_MANUFACTURER_HARVEST_TAGS.SUPPLIER_PORTAL,
  },
  {
    value: GLOBAL_MANUFACTURER_HARVEST_TAGS.SCRAPED,
    label: GLOBAL_MANUFACTURER_HARVEST_TAGS.SCRAPED,
  },
  {
    value: GLOBAL_MANUFACTURER_HARVEST_TAGS.MANUAL_ENTRY,
    label: GLOBAL_MANUFACTURER_HARVEST_TAGS.MANUAL_ENTRY,
  },
  {
    value: GLOBAL_MANUFACTURER_HARVEST_TAGS.API_INTEGRATION,
    label: GLOBAL_MANUFACTURER_HARVEST_TAGS.API_INTEGRATION,
  },
  {
    value: GLOBAL_MANUFACTURER_HARVEST_TAGS.CATALOGUE_UPLOADED,
    label: GLOBAL_MANUFACTURER_HARVEST_TAGS.CATALOGUE_UPLOADED,
  },
];

/**
 * Tags that are tracked in statistics (GDSN, Supplier Portal, Scraped)
 */
export const STATISTICAL_TAGS = [
  GLOBAL_MANUFACTURER_HARVEST_TAGS.GDSN,
  GLOBAL_MANUFACTURER_HARVEST_TAGS.SUPPLIER_PORTAL,
  GLOBAL_MANUFACTURER_HARVEST_TAGS.SCRAPED,
];

export default GLOBAL_MANUFACTURER_HARVEST_TAGS;
